import { requestStatuses as REQUEST_STATUSES } from '@/constants/requests';

// eslint-disable-next-line import/prefer-default-export
export function numberOfRequestsWithRequestsStatus(requests) {
  return requests.filter(req => req.status === REQUEST_STATUSES.REQUESTED).length;
}
